import SelectSortBy from './SelectSortBy.component';

export default SelectSortBy;
